module.exports = __webpack_public_path__ + "public/img/ico-tabbar-inactive-overview.61c957a2.svg";